export default __webpack_public_path__ + "static/media/sysops_karier.28880856.png";